// Loader components

import React from 'react';
import * as Motion from 'motion/react';
import './styles.scss';

const { motion } = Motion;


const Loader = () => (
  <motion.div
    key="loader"
    initial={{ opacity: 1 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="loader-wrapper">
    <div className="loader-icon">
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  </motion.div>
);

export const SectionLoader = () => (
  <div className="section-loader">
    <Loader/>
  </div>
);

export default Loader;
